<template>
    <div class="is-mobile">
        <div class="column box bg" style="overflow-x:auto;  min-height: 700px">
            <div class="columns is-mobile" style="border-bottom: 1px solid #6a85a7">
                <div class="column">
                    <div class="field has-addons is-pulled-left">
                        <div class="control">
                            <p class="is-size-4" style="min-width: 295px;">Report Summary</p>
                        </div>
                        <div class="control">
                            <button class="button is-primary btn-color" id="openReportBuildModal">Waiting Report Build List</button>
                        </div>
                    </div>
                </div>
                <div class="column">
                    <div class="field has-addons is-pulled-right">
                        <div class="control">
                            <input class="input is-normal input-width" @change="getReportSummaryList()" type="date" v-model="todayText">
                        </div>
                    </div>
                </div>
            </div>

            <div class="columns is-mobile">
                <div class="column">
                    <div class="field has-addons is-pulled-left">
                        <div class="control">
                            <input class="input is-normal input-width" type="text" v-model="searchText" @keyup="fillsearchField()"
                                   placeholder="Search a Report Summary">
                        </div>
                        <div class="control">
                            <a class="button">
                                <font-awesome-icon class="is-size-5 color-default" icon="search"/>
                            </a>
                        </div>
                    </div>
                </div>
                <div class="column">
                    <div class="field has-addons is-pulled-right">
                        <div class="control">
                            <!--              <input class="input is-normal input-width" :type="customFormatter" v-model="forceSelectedDay">-->


                        </div>
                        <div class="control">
                            <button class="button is-primary btn-color" id="openForceModal">Generate Reports Which Selected Day</button>
                        </div>
                    </div>
                </div>
            </div>
            <div class="columns"  style="justify-content: right;">
                <div class="column has-text-right">
                    <div class="tooltip"><font-awesome-icon class="is-size-5 is-warning" icon="info"/>
                        <div class="tooltiptext">
                            <ul style="list-style: disc outside">
                                <li style="margin-left: 20px">
                                    <p style="margin-bottom: 10px">You can sort Report Summary by IDIPADLKVOO, Sign Type, Prepared LVC, Leg No, ,Report Build Try DT Start, Report Build Try DT Finish,  STD Day, All Stat, Report Try Count, All Copy Status, Report Build Error, Which Local Path</p>
                                </li>
                                <li style="margin-left: 20px">
                                    <p style="margin-bottom: 10px">You can Search Report Summary by Which Local Path, IDIPADLKVOO, Prepared LVC</p>
                                </li>
                                <li style="margin-left: 20px">
                                    <p style="margin-bottom: 10px">You can view the Report Summary and Transfer Summary on the Grid.</p>
                                </li>
                                <li style="margin-left: 20px">
                                    <p style="margin-bottom: 10px">You can redirect to Report Summary and Transfer Summary History page.</p>
                                </li>
                            </ul>
                        </div>
                    </div>
                </div>
            </div>
            <table>
                <thead>
                <tr>
                    <th></th>
                    <th title="ID Ipad Last Known Version On OCC">
                        <button class="t-sort"
                                @click="sortBy('IDIPADLKVOO')">IDIPADLKVOO
                            <font-awesome-icon class="sort-icon"
                                               :class="sort === 'IDIPADLKVOO' ? 'icon-color-white' : 'icon-color-default'"
                                               :icon="iconSort(sortDir, 'IDIPADLKVOO')"/>
                        </button>
                    </th>
                    <th>
                        <button class="t-sort" @click="sortBy('SignType')">Sign Type
                            <font-awesome-icon class="sort-icon"
                                               :class="sort === 'SignType' ? 'icon-color-white' : 'icon-color-default'"
                                               :icon="iconSort(sortDir, 'SignType')"/>
                        </button>
                    </th>
                    <th>
                        <button class="t-sort" @click="sortBy('PreparedLVC')">Prepared LVC
                            <font-awesome-icon class="sort-icon"
                                               :class="sort === 'PreparedLVC' ? 'icon-color-white' : 'icon-color-default'"
                                               :icon="iconSort(sortDir, 'PreparedLVC')"/>
                        </button>
                    </th>
                    <th>
                        <button class="t-sort" @click="sortBy('LegNo')">Leg No
                            <font-awesome-icon class="sort-icon" :class="sort === 'LegNo' ? 'icon-color-white' : 'icon-color-default'"
                                               :icon="iconSort(sortDir, 'LegNo')"/>
                        </button>
                    </th>
                    <th>
                        <button class="t-sort" @click="sortBy('ReportBuildTryDTStart')">Report Build Try DT Start
                            <font-awesome-icon class="sort-icon"
                                               :class="sort === 'ReportBuildTryDTStart' ? 'icon-color-white' : 'icon-color-default'"
                                               :icon="iconSort(sortDir, 'ReportBuildTryDTStart')"/>
                        </button>
                    </th>
                    <th>
                        <button class="t-sort" @click="sortBy('ReportBuildTryDTFinish')">Report Build Try DT Finish
                            <font-awesome-icon class="sort-icon"
                                               :class="sort === 'ReportBuildTryDTFinish' ? 'icon-color-white' : 'icon-color-default'"
                                               :icon="iconSort(sortDir, 'ReportBuildTryDTFinish')"/>
                        </button>
                    </th>
                    <th>
                        <button class="t-sort" @click="sortBy('STDDay')">STD Day
                            <font-awesome-icon class="sort-icon"
                                               :class="sort === 'STDDay' ? 'icon-color-white' : 'icon-color-default'"
                                               :icon="iconSort(sortDir, 'STDDay')"/>
                        </button>
                    </th>
                    <th>
                        <button class="t-sort" @click="sortBy('ALL_STAT')">ALL_STAT
                            <font-awesome-icon class="sort-icon"
                                               :class="sort === 'ALL_STAT' ? 'icon-color-white' : 'icon-color-default'"
                                               :icon="iconSort(sortDir, 'ALL_STAT')"/>
                        </button>
                    </th>
                    <th>
                        <button class="t-sort" @click="sortBy('ReportTryCount')">Report Try Count
                            <font-awesome-icon class="sort-icon"
                                               :class="sort === 'ReportTryCount' ? 'icon-color-white' : 'icon-color-default'"
                                               :icon="iconSort(sortDir, 'ReportTryCount')"/>
                        </button>
                    </th>
                    <th>
                        <button class="t-sort" @click="sortBy('AllCopyStatus')">All Copy Status
                            <font-awesome-icon class="sort-icon"
                                               :class="sort === 'AllCopyStatus' ? 'icon-color-white' : 'icon-color-default'"
                                               :icon="iconSort(sortDir, 'AllCopyStatus')"/>
                        </button>
                    </th>
                    <th>
                        <button class="t-sort" @click="sortBy('ReportBuildError')">Report Build Error
                            <font-awesome-icon class="sort-icon"
                                               :class="sort === 'ReportBuildError' ? 'icon-color-white' : 'icon-color-default'"
                                               :icon="iconSort(sortDir, 'ReportBuildError')"/>
                        </button>
                    </th>
                    <th>
                        <button class="t-sort" @click="sortBy('WhichLocalPath')">Which Local Path
                            <font-awesome-icon class="sort-icon"
                                               :class="sort === 'WhichLocalPath' ? 'icon-color-white' : 'icon-color-default'"
                                               :icon="iconSort(sortDir, 'WhichLocalPath')"/>
                        </button>
                    </th>
                    <th>
                        <button class="t-sort">Action</button>
                    </th>
                </tr>
                </thead>
                <tbody v-if="paginate && paginate.length">
                <template v-for="(report, index) in paginate">
                    <tr :key="report.id + '_' +index" :class="!isToggleActived[report.id] ? 'bg-default' : 'bg-white'">
                        <td @click="toggle(report.id)">
                            <font-awesome-icon :icon="iconToggle(opened.includes(report.id))" size=""/>
                        </td>
                        <td :class="sort === 'IDIPADLKVOO' ? 'bg-sort-selected' : 'bg-default'">{{ report.idipadlkvoo }}</td>
                        <td :class="sort === 'SignType' ? 'bg-sort-selected' : 'bg-default'">{{ report.signType }}</td>
                        <td :class="sort === 'PreparedLVC' ? 'bg-sort-selected' : 'bg-default'">{{ report.preparedLVC }}</td>
                        <td :class="sort === 'LegNo' ? 'bg-sort-selected' : 'bg-default'">{{ report.legNo }}</td>
                        <td :class="sort === 'ReportBuildTryDTStart' ? 'bg-sort-selected' : 'bg-default'">{{
                            report.reportBuildTryDTStart | longFormatFromDT
                            }}
                        </td>
                        <td :class="sort === 'ReportBuildTryDTFinish' ? 'bg-sort-selected' : 'bg-default'">{{
                            report.reportBuildTryDTFinish | longFormatFromDT
                            }}
                        </td>
                        <td :class="sort === 'STDDay' ? 'bg-sort-selected' : 'bg-default'">{{report.stdDay | longFormatFromDT }}</td>
                        <td :class="sort === 'ALL_STAT' ? 'bg-sort-selected' : 'bg-default'">{{report.alL_STAT }}</td>
                        <td :class="sort === 'ReportTryCount' ? 'bg-sort-selected' : 'bg-default'">{{ report.reportTryCount }}</td>
                        <td :class="sort === 'AllCopyStatus' ? 'bg-sort-selected' : 'bg-default'">{{ report.allCopyStatus }}</td>
                        <td class="last-error" style="word-wrap: break-word;max-width: 150px" :class="sort === 'ReportBuildError' ? 'bg-sort-selected' : 'bg-default'">

                            <span v-if="!readMoreBuildError[report.id + '_' + index]">{{ report.reportBuildError.slice(0,10) }}</span>
                            <a v-if="!readMoreBuildError[report.id + '_' + index] && report.reportBuildError !== ''" @click="activeReadMore(report.id + '_' + index)">.. read more</a>
                            <span v-if="readMoreBuildError[report.id + '_' + index]" v-html="report.reportBuildError"></span>
                        </td>
                        <td style="word-wrap: break-word;max-width: 150px" :class="sort === 'WhichLocalPath' ? 'bg-sort-selected' : 'bg-default'">
                            <span v-if="!readMoreBuildError[report.id + '_' + index]">{{ report.whichLocalPath.slice(0,10) }}</span>
                            <a v-if="!readMoreBuildError[report.id + '_' + index] && report.whichLocalPath !== ''" @click="activeReadMore(report.id + '_' + index)">.. read more</a>
                            <span v-if="readMoreBuildError[report.id + '_' + index]" v-html="report.whichLocalPath"></span>
                        </td>
                        <td :class="sort === 'AllCopyStatus' ? 'bg-sort-selected' : 'bg-default'"><button @click="GetDetailsOfTransferSummaryByIPADLKVOO(report.idipadlkvoo)" class="button btn-detail">Detail</button></td>

                    </tr>
                    <tr :key="report.id" v-if="opened.includes(report.id)">
                        <td colspan="14" class="table-center sub-table bg-white">
                            <table class="box child-table-d-table" style="padding: 8px;">
                                <thead>
                                <tr class="bg-default">
                                    <th class="color-default p-8px">IDIPADLKVOO</th>
                                    <th class="color-default p-8px">Process Type</th>
                                    <th class="color-default p-8px">Sign Type</th>
                                    <th class="color-default p-8px">Prepared LVC</th>
                                    <th class="color-default p-8px">Copy Try DT</th>
                                    <th class="color-default p-8px">Copy Try Count</th>
                                    <th class="color-default p-8px">Folder Size</th>
                                    <th class="color-default p-8px">Copy Last Error</th>
                                    <th class="color-default p-8px">Which Path</th>
                                </tr>
                                </thead>
                                <tbody v-if="report.transferSummary !== null || report.transferSummary !== []">
                                <tr v-for="reportTransfer in JSON.parse(report.transferSummary)" :key="reportTransfer.ID">
                                    <td class="p-8px">{{ reportTransfer.IDIPADLKVOO }}</td>
                                    <td class="p-8px">{{ reportTransfer.ProcessType }}</td>
                                    <td class="p-8px">{{ reportTransfer.SignType }}</td>
                                    <td class="p-8px">{{ reportTransfer.PreparedLVC }}</td>
                                    <td class="p-8px">{{ reportTransfer.CopyTryDT | longFormatFromDT }}</td>
                                    <td class="p-8px">{{ reportTransfer.CopyTryCount }}</td>
                                    <td class="p-8px">{{ reportTransfer.FolderSize }} MB</td>
                                    <td class="p-8px word-warp last-error" style="overflow-wrap: break-word;max-width: 150px;" >
                                        <span v-if="!readMoreBuildError[reportTransfer.ID + '_' + index]">{{ reportTransfer.CopyLastError.slice(0,10) }}</span>
                                        <button  @click="activeReadMore(reportTransfer.ID + '_' + index)" v-if="!readMoreBuildError[reportTransfer.ID + '_' + index] && reportTransfer.CopyLastError !== ''">.. read more</button>
                                        <span v-if="readMoreBuildError[reportTransfer.ID + '_' + index]" v-html="reportTransfer.CopyLastError"></span>
                                    </td>
                                    <td class="p-8px word-warp" style="overflow-wrap: break-word;max-width: 150px;" >
                                        <span v-if="!readMoreBuildError[reportTransfer.ID + '_' + index]">{{ reportTransfer.WhichPath.slice(0,10) }}</span>
                                        <a v-if="!readMoreBuildError[reportTransfer.ID + '_' + index] && reportTransfer.WhichPath !== ''" @click="activeReadMore(reportTransfer.ID + '_' + index)">.. read more</a>
                                        <span v-if="readMoreBuildError[reportTransfer.ID + '_' + index]" v-html="reportTransfer.WhichPath"></span>
                                    </td>
                                </tr>
                                </tbody>
                                <tbody v-else>
                                <tr colspan="14">
                                    <td colspan="14" class="last-error has-text-centered"> No Data </td>
                                </tr>
                                </tbody>
                            </table>
                        </td>
                    </tr>
                </template>
                </tbody>
            </table>
        </div>
        <!--    <PAGINATION> -->
        <div class="">
            <div class="level" style="justify-content: center; margin-top: 20px">
                <nav class="pagination" role="navigation" aria-label="pagination">
                    <ul class="pagination-list">
                        <li v-if="pageNavigationInfo.hasFirstPageNavigation">
                            <div @click="setPage(1)" class="pagination-link bg-default color-default">
                                <font-awesome-icon class="is-size-5 color-default" icon="backward"/>
                            </div>
                        </li>
                        <li v-for="index in pageNavigationInfo.pageCount" :key="index">
                            <div
                                    :style="currentPage === pageNavigationInfo.start + index ? 'background-color:#6a85a7;' : 'background-color:#f8f6ff'"
                                    @click="setPage(pageNavigationInfo.start + index)" class="pagination-link">
                                <a :style="currentPage === pageNavigationInfo.start + index ? 'color:white;' : 'color:#6a85a7'"
                                   :class="[currentPage === pageNavigationInfo.start + index ? 'current':'']">{{
                                    pageNavigationInfo.start + index
                                    }}</a>
                            </div>
                        </li>
                        <li v-if="pageNavigationInfo.hasLastPageNavigation">
                            <div @click="setPage(pageNavigationInfo.total)" class="pagination-link bg-default color-default">
                                <font-awesome-icon class="is-size-5 color-default" icon="forward"/>
                            </div>
                        </li>
                    </ul>
                </nav>
            </div>
        </div>
        <!--    </PAGINATION> -->
        <!--    <FORCE MODAL> -->
        <div class="modal  has-text-centered" id="ForceModal">
            <div class="modal-background"></div>
            <div class="box modal-card" style="height: 661px;width: 550px;">

                <section class="modal-card-body">

                    <h2 class="h-100 is-size-3">You are about regenerate reports of the selected days.</h2>
                    <p class="mt-4 is-size-6" style="color: gray">When you force with the day you choose, All reports of the selected day will be regenerate.</p>
                    <br>

                    <datepicker class="bg-red" input-class="input-class" style="text-align: center; margin-top: 18px;height: 300px;"  v-model="forceSelectedDay"
                                :format="customFormatter"
                                :disabledDates="disabledDays">
                    </datepicker>
                    <br>
                    <br>
                    <div class="is-justify-content-center mt-4">
                        <button class="button btn-color" @click="ForceRegenateReportWhichSeletedDay()" style="margin-right: 50px;">Force</button>
                        <button class="button close is-danger" id="closeForce">Cancel</button>
                    </div>

                </section>



                <footer class="is-justify-content-center mt-4">
                   <!-- <button class="button btn-color" @click="ForceRegenateReportWhichSeletedDay()" style="margin-right: 50px;">Force</button> -->
                   <!-- <button class="button close is-danger" id="closeForce">Cancel</button> -->
                </footer>

            </div>
        </div>
        <!--    </FORCE MODAL> -->
        <!--    <Build List MODAL> -->
        <div class="modal has-text-centered" id="BuildListModal">
            <div class="modal-background closeReportBuild"></div>
            <div class="modal-card modal-card-size bg-default">
                <header class="modal-card-head">
                    <p class="modal-card-title">Waiting Report Build List</p>
                    <button class="btn-refresh mr-10p" @click="getReportBuildWaitingList()"><font-awesome-icon icon="sync-alt"></font-awesome-icon></button>

                    <button class="delete" id="closeReportBuild"></button>
                </header>
                <section class="modal-card-body">
                    <div class="tableFixHead column box bg" style="overflow-x:auto;">
                        <table style="overflow-x:auto">
                            <thead>
                            <tr>
                                <th>FKeyForZip</th>
                                <th>JLVT</th>
                                <th>ipadDeviceUID</th>
                                <th>btoLVC</th>
                                <th>alLVC</th>
                                <th>AircraftType</th>
                                <th>LegNo</th>
                                <th>ModDT</th>
                                <th>STD</th>
                                <th>STA</th>
                                <th>ATD</th>
                                <th>ATA</th>
                                <th>CARRIER</th>
                                <th>FnoWithSuffix</th>
                                <th>CallSign</th>
                                <th>AircraftReg</th>
                                <th>Departure</th>
                                <th>Arrival</th>
                                <th>Captain1</th>
                                <th>Captain2</th>
                                <th>Captain3</th>
                                <th>CabinCrew</th>
                                <th>BTO_SignedBy</th>
                                <th>AL_SignedBy</th>
                                <th>STDDay</th>
                            </tr>
                            </thead>
                            <tbody>
                            <template>
                                <tr v-for="data in reportBuildList" :key="data.id">
                                    <td>{{ data.FKeyForZip }}</td>
                                    <td>{{ data.JLVT }}</td>
                                    <td>{{ data.ipadDeviceUID }}</td>
                                    <td>{{ data.btoLVC }}</td>
                                    <td>{{ data.alLVC }}</td>
                                    <td>{{ data.AircraftType }}</td>
                                    <td>{{ data.LegNo }}</td>
                                    <td>{{ data.ModDT }}</td>
                                    <td>{{ data.STD }}</td>
                                    <td>{{ data.STA }}</td>
                                    <td>{{ data.ATD }}</td>
                                    <td>{{ data.ATA }}</td>
                                    <td>{{ data.CARRIER }}</td>
                                    <td>{{ data.FnoWithSuffix }}</td>
                                    <td>{{ data.CallSign }}</td>
                                    <td>{{ data.AircraftReg }}</td>
                                    <td>{{ data.Departure }}</td>
                                    <td>{{ data.Arrival }}</td>
                                    <td>{{ data.Captain1 }}</td>
                                    <td>{{ data.Captain2 }}</td>
                                    <td>{{ data.Captain3 }}</td>
                                    <td>{{ data.CabinCrew }}</td>
                                    <td>{{ data.BTO_SignedBy }}</td>
                                    <td>{{ data.AL_SignedBy }}</td>
                                    <td>{{ data.STDDay }}</td>
                                </tr>
                            </template>
                            </tbody>
                        </table>
                    </div>
                </section>
            </div>
        </div>
        <!--    </Build List MODAL> -->
    </div>
</template>

<script>
    import {mapActions} from "vuex";
    import ReportSummary from "../../../services/reportsummary.service";  // "../../services/"   /* // reportsummary.service.js" */
    import * as moment from "moment";
    import Datepicker from 'vuejs-datepicker';
    export default {
        name: "ReportSummary",
        components: {
            Datepicker
        },
        data() {
            return {
                opened: [],
                searchText: "",
                tempSearch: "",
                reportSummaryList: [],
                reportBuildList: [],
                test: [],
                resultCount: 0,
                currentPage: 1,
                pageRange: 3,
                itemsPerPage: 20,
                pageNavigationInfo: {},
                isToggleActived: [],
                readMoreBuildError: [],
                moreError: [],
                disabledDays :null,
                forceSelectedDay: new Date(),
                searchDate : new Date(),
                todayText: this.$route.params.date, //;  new Date().toISOString().substr(0, 10),
                iconList: [
                    {
                        type: true,
                        icon: "plus",
                    },
                    {
                        type: false,
                        icon: "minus",
                    },
                    {
                        type: "default",
                        icon: "sort",
                    },
                    {
                        type: "asc",
                        icon: "sort-up",
                    },
                    {
                        type: "desc",
                        icon: "sort-down",
                    }
                ],
                sort: 'id',
                sortDir: 'default'
            }
        },
        methods: {
            ...mapActions("reportsummary",["getReportList", "getReportBuildList"]),
            //...mapActions["getReportList", "getReportBuildList"],
            async getReportSummaryList() {
                try {
                    //let list = await this.$store.dispatch("reportSummary/getReportList") //todayText
                    //alert("let list = await this.getReportList();")
                    let STDDay = moment(this.todayText).format('YYYY-MM-DD');
                    let list = await this.getReportList(STDDay);
                    //alert("let list = await this.getReportList(); done")
                    this.setReportSummaryList(list)
                    console.log("asdasdasd");
                    console.log(list);
                } catch (e) {
                    this.$notify({title: "Error", text:"Error on getReportSummaryList, "+ e.message, type: "error"});
                }
            },
            customFormatter
                (date) {
                //alert(moment(date).format('YYYY-MM-DD'));
                this.forceSelectedDay = moment(date).format('YYYY-MM-DD');
                return moment(date).format('YYYY-MM-DD');
            },
            async getReportBuildWaitingList() {
                try {
                        let list = await this.getReportBuildList();
                    //let list = await this.$store.dispatch("reportSummary/getReportBuildList")
                    this.reportBuildList = list;
                } catch (e) {
                    this.$notify({title: "Error", text:"Error on getReportBuildWaitingList, "+ e.message, type: "error"});
                }
            },

            async GetDetailsOfTransferSummaryByIPADLKVOO(IDIPADLKVOO)
            {

                try {
                    console.log(IDIPADLKVOO)
                    // reportsummaryHistory ekranına route ettrimemiz gerekiyor.  // aynı zamanda IDIPADLKVOO parametre url de bulunması gerekiyor.

                    this.$router.push({name: 'ReportSummaryHistory', params: {IdIpadLKVOO: IDIPADLKVOO}});


                } catch (e) {
                    this.$notify({title: "Error", text:"Error on getReportBuildWaitingList, "+ e.message, type: "error"});
                }

            },

            async ForceRegenateReportWhichSeletedDay() {
                try {

                    var result = await ReportSummary.RegenerateReports_Service(this.forceSelectedDay);

                    this.$notify({title: "success", text: result , type: "success"});

                }
                catch (e)
                {
                    this.$notify({title: "Error", text:"Error on ForceRegenateReportWhichSeletedDay function " + e.message, type: "error"});
                }
            },

            async ForceRegenerateReportSelectedIpadLKVOO(IPADLKVOO)
            {
                try
                {
                    console.log(IPADLKVOO)
                    var result = await ReportSummary.RegenerateReports_Service_ByIPADLKVOO(IPADLKVOO)
                    this.$notify({title: "success", text: result , type: "success"});

                }
                catch (e)
                {
                    this.$notify({title:"Error",text:"Error on Force Regenerate ReportSelected IpadLKVOO function"+ e.message, type:"error"})
                }
            },

            toggle(id) {
                const index = this.opened.indexOf(id);
                if (index > -1) {
                    this.opened.splice(index, 1)
                    this.isToggleActived[id] = false;

                } else {
                    this.opened.push(id)
                    this.isToggleActived[id] = true;
                }
            },
            iconToggle(opened) {
                if (!opened) {
                    return this.iconList.find(x => x.type === true).icon
                } else {
                    return this.iconList.find(x => x.type === false).icon
                }
            },
            setResultCount(count) {
                this.resultCount = count;
            },
            setCurrentPage(currentPage) {
                this.currentPage = currentPage;
            },
            setPage(pageNumber) {
                this.currentPage = pageNumber;
                this.buildPageNavigationInfo()
            },
            setReportSummaryList(list) {
                this.reportSummaryList = list;
            },
            buildPageNavigationInfo() {
                let _total = this.totalPages;
                let _current = this.currentPage;

                let firstPage = Math.max(1, _current - this.pageRange);
                let lastPage = Math.min(_total, _current + this.pageRange);

                this.pageNavigationInfo = {
                    start: firstPage - 1,
                    end: lastPage,
                    hasFirstPageNavigation: firstPage > 1,
                    hasLastPageNavigation: lastPage < _total,
                    pageCount: lastPage - firstPage + 1,
                    total: _total,
                }
            },
            sortBy(sortName) {
                if (sortName === this.sort) {
                    this.sortDir = (this.sortDir === 'asc') ? 'desc' : 'asc';
                } else {
                    this.sortDir = 'asc';
                }
                this.sort = sortName;
            },
            iconSort(sort, name) {
                if (name === this.sort) {
                    return this.iconList.find(x => x.type === sort).icon
                } else {
                    return this.iconList.find(x => x.type === 'default').icon
                }
            },
            async fillsearchField() {
                if (this.searchText !== "")
                    setTimeout(() => this.tempSearch = this.searchText, 1000)
                else {
                    this.tempSearch = "";
                    this.searchText = "";
                }
            },

            activeReadMore(id) {
                const index = this.moreError.indexOf(id);
                if (index > -1) {
                    this.opened.splice(index, 1)
                    this.readMoreBuildError[id] = false;

                } else {
                    this.opened.push(id)
                    this.readMoreBuildError[id] = true;
                }
            },

        },


        async created() {

            try {
                await this.getReportSummaryList();
            }
            catch(e)
            {
                this.$notify({title: "Error", text:"Couldn't get Report Summary list" , type: "error"});
            }

            try {
                await this.getReportBuildWaitingList();
            }
            catch(e)
            {
                this.$notify({title: "Error", text:"Couldn't get Report Building Waiting list." , type: "error"});
            }


            this.currentPage = 1;

            this.buildPageNavigationInfo();

            var utcDate = new Date()
            utcDate.setUTCHours(utcDate.getHours());
            var calcAddday = utcDate;
            calcAddday.setDate(calcAddday.getDate()-1);
            this.disabledDays = { from: calcAddday };

            // Force & Build List Modal
            const buildListModal = document.querySelector('#BuildListModal');
            const openReportBuildModal = document.querySelector('#openReportBuildModal');
            const closeReportBuild = document.querySelector('.closeReportBuild');
            const closeReportBuild2 = document.querySelector('#closeReportBuild');

            const forceModal = document.querySelector('#ForceModal');
            const openForceModal = document.querySelector('#openForceModal');
            const closeForce = document.querySelector('#closeForce');

            openReportBuildModal.addEventListener('click', () => {
                buildListModal.classList.add('is-active');
            })
            closeReportBuild.addEventListener('click', () => {
                buildListModal.classList.remove('is-active')
            })
            closeReportBuild2.addEventListener('click', () => {
                buildListModal.classList.remove('is-active')
            })
            openForceModal.addEventListener('click', () => {
                forceModal.classList.add('is-active');
            })
            closeForce.addEventListener('click', () => {
                forceModal.classList.remove('is-active')
            })
        },
        computed: {

            reportSummaryofDetails: function (value)
            {

                return JSON.parse(value)

                // if(this.transferHistory === undefined || this.transferHistory == [])
                // {
                //     return [];
                // }
                //
                // // this.CalculateFlightCounts();
                // return this.transferHistory;

            },


            totalPages() {
                return Math.ceil(this.resultCount / this.itemsPerPage);
            },

            paginate() {
                if (!this.reportSummaryList) {
                    return
                }

                this.setReportSummaryList(this.reportSummaryList);

                let list = this.reportSummaryList.filter((post) => {
                    console.log(post)
                    return post.whichLocalPath.toLowerCase().match(this.searchText.toLowerCase())
                        || post.idipadlkvoo.toString().match(this.searchText)
                        || post.preparedLVC.toString().match(this.searchText);
                })
                this.setResultCount(list.length);
                if (this.currentPage === 0) this.setCurrentPage(1)
                if (this.currentPage >= this.totalPages) {
                    this.setCurrentPage(this.totalPages)
                }
                let index = this.currentPage * this.itemsPerPage - this.itemsPerPage


                this.buildPageNavigationInfo()
                return list.slice(index, index + this.itemsPerPage).sort((a, b) => {
                    let dir = (this.sortDir === 'asc') ? 1 : -1;
                    if (a[this.sort] < b[this.sort]) {
                        return -1  * dir;
                    } else if (a[this.sort] > b[this.sort]) {
                        return 1 * dir;
                    } else {
                        return 0;
                    }
                })
            },

            today() {
                return new Date().toISOString().substr(0, 10);
            },
        },
        mounted() {
        },
    }
</script>

<style scoped>

    .heading__credits .heading__link {
        color: inherit;
    }

    .btn-color {
        background-color: #6a85a7 !important;
        color: white;
    }

    .btn-color:hover {
        color: white;
    }

    .input-width {
        width: 15em;
    }


    .box:not(:last-child) {
        margin-bottom: 0.5rem;
    }

    .heading__credits .heading__link {
        color: inherit;
    }

    ol {
        margin: 0;
        padding: 0;
    }

    .child-table-d-table {
        display: table !important;
        width: 85%;
        background-color: white;
        pointer-events: auto!important;
    }

    li {
        list-style: none;
    }

    * {
        box-sizing: border-box;
    }

    table {
        border-collapse: collapse;
        border-spacing: 0;
        width: 100%;
    }

    th {
        color: white !important;
    }
    th, td {
        text-align: left;
        padding: 8px 3px 8px 0;
    }

    .p-8px {
        padding: 5px;
    }

    thead tr:nth-child(1) {
        background-color: #6a85a7;
    }

    .box {
        color: #6a85a7;
    }


    .heading__credits .heading__link {
        color: inherit;
    }

    .bg {
        background-color: #f8f6ff;
    }

    .table-center {
        text-align: -webkit-center !important;
    }




    .t-sort {
        border: none;
        margin: 0;
        padding: 0;
        background: transparent;
        color: white;
        font-weight: bold;
        font-size: 16px;
        cursor: pointer;
    }

    .sort-icon {
        margin-left: 5px;
        font-size: 18px;
        color: #ffffff69;
    }

    .icon-color-white {
        color: #ffffff;
    }

    .icon-color-default {
        color: #ffffff69;
    }


    .bg-sort-selected {
        background-color: #eae7f3 !important;
    }

    .modal-card-size {
        min-height: calc(100vh - 40px);
        min-width: calc(200vh - 40px);
    }
    .delete {
        min-height: 20px;
        min-width: 20px;
        max-height: 30px;
        max-width: 30px;
        height: 25px;
        width: 25px;
        background-color: darkred;
    }

    tableFixHead table {
        background-color: #f8f6ff!important;
    }
    .modal-card-head {
        background-color: #f8f6ff!important;
    }
    .modal-card-title{
        color: #6a85a7!important;
    }
    .tableFixHead {
        height: calc(100vh - 150px);
        top: 0;
        width: 100%;
    }

    .tableOverflow {
        overflow: hidden;
        white-space: nowrap;
        text-overflow: ellipsis;
    }

    .mr-10p {
        margin-right: 10px;
    }
    .btn-refresh {
        border: none;
        border-radius: 10px;
        font-size: 15px;
        cursor: pointer;
        min-height: 20px;
        min-width: 20px;
        max-height: 30px;
        max-width: 30px;
        height: 30px;
        width: 30px;
        background-color: #48c78e;
        color: #fff;
    }
    .btn-detail {
        background-color: #f8f6ff;
        color: #6a85a7;
        border: 1px solid #6a85a7;
    }
    .btn-detail:hover {
        background-color: #6a85a7;
        color: #f8f6ff;
    }

    .tooltip {
        position: relative;
        display: inline-block;
    }

    .tooltip .tooltiptext {
        visibility: hidden;
        min-width: 400px;
        max-width: 420px;
        background-color: #6a85a7de;
        border:3px solid;
        border-color: #4f4f4f;
        color: #fff;
        border-radius: 6px;
        top: 100%;
        left: 50%;
        margin-left: -387px;
        padding: 10px;
        margin-right: 23px;
        margin-top: 13px;
        font-size: 15px;
        text-align: left;

        /* Position the tooltip */
        position: absolute;
        z-index: 1111;
    }

    .tooltip:hover .tooltiptext {
        visibility: visible;
    }
</style>
